import React from 'react'
import { Props } from './types'

/**
 * Component to render fontawesome icons for bootstrap, check the list at:
 * https://seantheme.com/color-admin/admin/html/ui_icons.html
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 */
const Icon: React.FC<Props> = ({ className, iconSet, size, type }) => {
    return <i className={`${iconSet} fa-${type} fa-${size} ${className}`} />
}

Icon.defaultProps = {
    iconSet: 'fas',
    size: '2x'
}

export default Icon
